<template>
    <div style="width: 100%">
        <div class="dx-invalid-message dx-overlay dx-widget dx-visibility-change-handler dx-invalid-message-auto" v-if="error.msgErrorVisible">
            <div class="dx-invalid-message" data-bind="dxControlsDescendantBindings: true" style="z-index: 1502">
                <div class="filter-message dx-overlay-content dx-resizable dx-invalid-message-content" style="width: auto; height: auto; z-index: 1502; margin: 0px; left: 0px; top: 0px; transform: translate(0px, 0px); transition: all 0s ease 0s;">{{error.msg}}</div>
            </div>
        </div>
        <dx-validator
            :validationRules="[ {type: validationRule || 'required'} ]"
            :adapter="{
                getValue: () => {
                    return this.valor;
                },
                applyValidationResults: validationResult
            }"
            ref="validator"></dx-validator>
    </div>
</template>

<script>
import { DxValidator } from "devextreme-vue";
export default {
    props: ['validationRule','valor'],
    components: {
        DxValidator
    },
    data() {
        return {
            error: {
                msgErrorVisible: false,
                msg: ''
            }
        }
    },
    methods: {
        validationResult(e) {
            //console.log(e)
            this.error.msg = (e.brokenRule || { message: '' }).message;
            this.error.msgErrorVisible = !e.isValid;
        }
    },
    watch: {
        valor() {
            this.$refs.validator.instance.validate();
        }
    }
}
</script>